import React from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import IntlMessage from '../../../../../../helpers/intlMessage';

function Item({ item, icone, id, apagar, detalhes }) {
  return (
    <Row style={{ marginTop: '16px', width: '100%' }}>
      <Col style={{ marginTop: '-10px' }}>
        <p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
          {item.numero}
        </p>
        <p id={`material_${id}`} style={{ fontSize: '14px', marginBottom: 0 }}>
          <strong><IntlMessage id="general.materialArchiving.material" />: </strong>
          {item.material && item.material.slice(0, 25)}
          {item.material && item.material.length > 25 && '...'}
          {item.material && item.material.length > 25 && (
            <UncontrolledTooltip placement='top' target={`material_${id}`}>
              {item.material}
            </UncontrolledTooltip>
          )}
        </p>
        <p
          id={`paciente_${id}`}
          style={{ fontSize: '14px', marginBottom: '2px' }}
        >
          <strong><IntlMessage id="general.materialArchiving.patient" />: </strong>
          {item.pacienteNome}
          <UncontrolledTooltip placement='top' target={`paciente_${id}`}>
            {item.pacienteNome}
          </UncontrolledTooltip>
        </p>
        {item.pacienteNomeSocial &&
          <p
            id={`nomesocial_${id}`}
            style={{ fontSize: '14px', marginBottom: '2px' }}
          >
            <strong><IntlMessage id="general.materialArchiving.socialName" />: </strong>
            {item.pacienteNomeSocial}
            <UncontrolledTooltip placement='top' target={`nomesocial_${id}`}>
              {item.pacienteNomeSocial}
            </UncontrolledTooltip>
          </p>}
        <p>
          <strong><IntlMessage id="general.materialArchiving.requester" />: </strong>
          {item.requisitante}
        </p>
      </Col>
      <div className='menu-right'>
        <div>
          <div
            id={`dtRequisicao_${id}`}
            className='badge badge-info'
            style={{ fontSize: '10px', marginBottom: '5px' }}
          >
            {item.dataAtualizacao}
            <UncontrolledTooltip placement='top' target={`dtRequisicao_${id}`}>
              <IntlMessage id="general.materialArchiving.dateOfChange" />
            </UncontrolledTooltip>
          </div>
          <div className='menu-card-right'>
            <i
              id={`cancelar_${id}`}
              style={{ marginRight: '8px' }}
              className='fas fa-trash-alt'
              onClick={() => apagar(item)}
            >
              <UncontrolledTooltip placement='top' target={`cancelar_${id}`}>
                <IntlMessage id="general.materialArchiving.cancel" />
              </UncontrolledTooltip>
            </i>

            <i
              id={`detalhes_${id}`}
              style={{ marginLeft: '10px' }}
              className='fas fa-search'
              onClick={() => detalhes(item)}
            >
              <UncontrolledTooltip placement='top' target={`detalhes_${id}`}>
                <IntlMessage id="general.materialArchiving.details" />
              </UncontrolledTooltip>
            </i>
          </div>
          <i
            onClick={() => detalhes(item)}
            id={`tipo_${id}`}
            className={`${icone} fa-2x`}
            style={{
              color: '#3076a8',
              fontSize: '1.5em'
            }}
          >
            <UncontrolledTooltip placement='top' target={`tipo_${id}`}>
              {item.tipoNome}
            </UncontrolledTooltip>
          </i>
          <i
            onClick={() => detalhes(item)}
            id={`destinoEntrega_${id}`}
            className={`${item.iconeDestino} fa-2x`}
            style={{
              color: '#32323d',
              fontSize: '1.5em',
              marginLeft: '10px'
            }}
          >
            <UncontrolledTooltip
              placement='top'
              target={`destinoEntrega_${id}`}
            >
              {item.destinoEntrega}
            </UncontrolledTooltip>
          </i>
        </div>
      </div>
    </Row>
  );
}

export default Item;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/Kamban/Item/index.js